<template>
  <span>
    <i class="fa fa-circle font-sm" :class="riskLevelColor(fraudRisk)" v-if="fraudRisk != null"></i>&nbsp;
    <span v-if="fraudRisk != null && (fraudRisk >= 900 && fraudRisk <= 1000)">Risco muito alto</span>
    <span v-else-if="fraudRisk != null && (fraudRisk >= 800 && fraudRisk <= 899)">Alto risco</span>
    <span v-else-if="fraudRisk != null && (fraudRisk >= 601 && fraudRisk <= 799)">Risco moderado</span>
    <span v-else-if="fraudRisk != null && (fraudRisk >= 301 && fraudRisk <= 600)">Risco neutro</span>
    <span v-else-if="fraudRisk != null && (fraudRisk >= 101 && fraudRisk <= 300)">Baixo risco</span>
    <span v-else-if="fraudRisk != null && (fraudRisk >= 0 && fraudRisk <= 100)">Risco muito baixo</span>
    <span v-else>Lojista sem análise de risco</span>
  </span>
</template>

<script>
export default {
  name: 'SellerRiskScore',
  props: {
    fraudRisk: null
  },
  methods: {
    riskLevelColor (fraudRisk) {
      if (fraudRisk == null) return 'badge-light'

      switch (true) {
        case (fraudRisk >= 0 && fraudRisk <= 100) : return 'dark-green-color'
        case (fraudRisk >= 101 && fraudRisk <= 300) : return 'ligth-green-color'
        case (fraudRisk >= 301 && fraudRisk <= 600) : return 'blue-color'
        case (fraudRisk >= 601 && fraudRisk <= 799) : return 'orange-color'
        case (fraudRisk >= 800 && fraudRisk <= 899) : return 'ligth-red-color'
        case (fraudRisk >= 900 && fraudRisk <= 1000) : return 'dark-red-color'
        default: return 'text-gray-400'
      }
    }
  }
}
</script>

<style>
.dark-green-color {
  color: #57B651;
}

.ligth-green-color {
  color: #9ACC83;
}

.blue-color {
  color: #5DAADC;
}

.orange-color {
  color: #FBB247;
}

.ligth-red-color {
  color: #EA2F34;
}

.dark-red-color {
  color: #BC2227;
}
</style>
